<template>
<div>

<!-- header -->

<div class="contenttopbar grid px-3 mt-1">
<div class="col-10 md:col-9">
<h3 class="text-primary mb-3 mt-3 font-medium">{{title}}</h3>
</div>

<div class="col-2 md:col-3">

<div class="flex align-items-center justify-content-end">



<div class="hide_on_mobile "><Button type="button" :class="'p-button-info p-button-outlined p-button-sm mt-2 mr-2'" :label="$store.state.languages.lang_phrases.pdf_dokuman" :icon="'pi pi-file-pdf'" @click="downloadPdf" /></div>
<div class="show_on_mobile"><Button type="button" :class="'p-button-info p-button-outlined p-button-sm mt-2 mr-2'" :icon="'pi pi-file-pdf'" @click="downloadPdf" /></div>

<div class="hide_on_mobile "><Button type="button" :class="'p-button-danger p-button-outlined p-button-sm mt-2'" :label="$store.state.languages.lang_phrases.geri_don" :icon="'pi pi-arrow-left'" @click="goToUrl" /></div>
<div class="show_on_mobile"><Button type="button" :class="'p-button-danger p-button-outlined p-button-sm mt-2'" :icon="'pi pi-arrow-left'" @click="goToUrl" /></div>





</div>

</div>
</div>



<!-- header -->

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">

<div class="content_card mt-4" >
<div class="grid">
<div class="col-12">
<div class="content_card_content " v-if="!loading">
<div class="editor_pdf_area">
<canvas ref="canvas" width="1588" height="2246"></canvas>
</div>
</div>
</div>
</div>
</div>
</template>



</div>	
</template>

<script>
import { fabric } from 'fabric';
import { jsPDF } from "jspdf";
export default {

  name: 'SupplierAdmincard',

  data () {
    return {
    	loading:true,
    	item:null,
    }
  },
  async mounted()
  {
  	
  	await this.getData()
  	await setTimeout(()=>{
  		const ref = this.$refs.canvas;
  		ref.height = (this.pages.length)*2246
		this.canvas = new fabric.Canvas(ref);
  	},500)
  	
  },
  computed:{
  	title()
  	{

  		if(this.item && this.item.translations.length)
  		{
  			let translation = this.item.translations.find((item)=>{
  				return item.language_id == this.$store.state.auth.user.preflang_id
  			})
  			if(translation)
  			{
  				return translation.translation
  			}
  		}

  		return this.$store.state.languages.lang_phrases.tedarikci_karti
  	},
  	pages()
  	{
  		let pages = []
  		if(this.item && this.item.translations.length)
  		{
  			let translation = this.item.translations.find((item)=>{
  				return item.language_id == this.$store.state.auth.user.preflang_id
  			})
  			if(translation)
  			{
  				for(let page of translation.scorecardpages)
  				{
  					page.content = JSON.parse(page.content)
  					pages.push(page)
  				}
  			}
  		}

  	return pages 
  	}
  },
  methods:{
  	downloadPdf()
  	{
  		var imgData = this.canvas.toDataURL("image/jpeg", 1.0);
  		//var pdf = new jsPDF("p", "px", "a4");

  		var imgWidth = 397; 
      var pageHeight = 610;  

      let canvas_height = 610*(this.pages.length)
      var imgHeight = canvas_height * imgWidth / 397;

      //var imgHeight = this.canvas.height * imgWidth / this.canvas.width;
      var heightLeft = imgHeight;

      //var doc = new jsPDF('p', 'px');
      var doc = new jsPDF("p", "px", "a4");
      var position = 0;

      doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 1) {
        position = heightLeft - imgHeight;
        doc.addPage();
        doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      let file_name = this.item.name
		  if(this.item.translations.length)
		  {
		  	let translation = this.item.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
		  	if(translation)
		  	{
		  		name = translation.translation
		  	}
		  }


      doc.save(file_name + '.pdf');


  	},
  	async jsonDatatoFabricItem(item,pageindex)
  	{
  		if(item.itemtype=="textbox")
  		{
  			var text = new fabric.Textbox(item.text, { 
	  			left: item.left, 
	  			top: item.top+(pageindex*2246),
	  			width:item.width,
	  			height:item.height,
	  			fontFamily: item.fontFamily,
	    		fontWeight: item.fontWeight,
	    		textAlign:item.textAlign,
		      	hasControls:false,
	  			fontSize:item.fontSize, 
	  			fill:item.fill,
					  		selectable:false,
					  		evented:false,
		  		itemtype:"textbox"
	  		});
	  		this.canvas.add(text);
  		}
  		if(item.itemtype=="data")
  		{
  			let the_data
  			if(item.datatype=="customattribute")
  			{
  				let attribute_data  = await this.generalApiGetWithoutLoader("get_supplier_brand_scorecard_data/"+this.$route.params.id+"/admin/"+item.customattribute_id+"/customattribute")
  				
  				if(attribute_data && attribute_data.translations.length)
  				{
  					let attribute_data_translation = attribute_data.translations.find((element)=>{return element.language_id==this.$store.state.auth.user.preflang_id})
	  				if(attribute_data_translation)
	  				{
	  					the_data = attribute_data_translation.translation
	  				}
  				}
  				

  			}
  			if(item.datatype=="reportcolumn")
  			{
  				the_data  = await this.generalApiGetWithoutLoader("get_supplier_brand_scorecard_data/"+this.$route.params.id+"/admin/"+item.reportcolumn_id+"/reportcolumn")
  			}

  			if(item.datatype=="suppliername")
  			{
  				the_data  = this.$store.state.suppliers.supplier.name
  			}

  			if(item.datatype=="suppliercode")
  			{
  				the_data  = this.$store.state.suppliers.supplier.suppliercode
  			}

  			if(the_data)
  			{
  				the_data = the_data.toString()
  				var text = new fabric.Text(the_data, { 
		  			left: item.left, 
		  			top: item.top+(pageindex*2246),
		  			width:item.width,
		  			height:item.height,
		  			fontFamily: item.fontFamily,
		    		fontWeight: item.fontWeight,
		    		textAlign:item.textAlign,
			      hasControls:false,
		  			fontSize:item.fontSize, 
		  			fill:item.fill,
		  			datatype:item.datatype,
		  			customattribute_id:item.customattribute_id,
		  			report_id:item.report_id,
		  			reportcolumn_id:item.reportcolumn_id,
		  			questionlist_id:item.questionlist_id,
		  			period_id:item.period_id,
					  selectable:false,
					  evented:false,
		  			itemtype:"data"
		  		});
		  		this.canvas.add(text);
  			}
  			
  				
  		}
  		if(item.itemtype=="image")
  		{
  				let img_url = item.img_url
  				
  				fetch(img_url)
			    .then(result => result.blob())
			    .then(blob => {
			    	
			        const url = URL.createObjectURL(blob);
			        fabric.Image.fromURL(url, (img)=> {
			  			img.scaleToWidth(1588);
			  			img.set({  				
				      	hasControls:false,
			  				itemtype:"image",
			  				left: item.left, 
		  					top: item.top+(pageindex*2246),
		  					img_url:img_url,
		  					scaleX:item.scaleX,
					  		selectable:false,
					  		evented:false,
		  					scaleY:item.scaleY
			  			})
						  this.canvas.add(img);	
						});
			    });
  		}
  	},
  	goToUrl()
    {
      this.$router.push({ name: "SupplierAdminCards"})    	
    },
    async getData()
    {
    	this.loading = await true
    	this.item = await this.generalApiGetWithoutLoader("get_supplier_brand_scorecard/"+this.$route.params.card_id) 
      	
      	console.log(this.item)
      	


      	this.loading = await false
      	setTimeout(()=>{
      		//for(let page of this.pages)
      		for (let i = 0; i < this.pages.length; i++)
	      	{
	      		console.log(this.pages[i])
	      		if(this.pages[i].content)
	      		{
	      			for(let item of this.pages[i].content)
		      		{
		      			this.jsonDatatoFabricItem(item,i)
		      		}
	      		}
	      		
	      	}
      	},1000)
    },

  },
}
</script>

<style lang="css" scoped>
.editor_pdf_area{
	width: 1588px;
	min-height: 1123px;
	position: relative;
	background-color: #fff;
	scale: 0.5;
	transform-origin: top left;
}
</style>